let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("i564Y")).then(() => parcelRequire('h5Ce7'));